import {useMemo} from 'react';
import {
	getTimeRegistrationSettings,
	isBillableSplitAllowed,
	type TimeRegistrationSettings,
} from '../util/cache/TimeRegistrationSettingsUtil';

//TODO: add all time registration settings to this.
export function useTimeRegistrationSettings(): Pick<
	TimeRegistrationSettings,
	'allowInternalTime' | 'allowOutsideTaskDates' | 'allowExceedingEstimate' | 'allowOutsideProjectDates' | 'requireNote'
> {
	return useMemo(() => {
		const timeRegistrationSettings = getTimeRegistrationSettings();
		return {
			allowBillableSplit: isBillableSplitAllowed(), // TODO: remove the logic in this custom getter, and return timeRegistrationSettings directly.
			allowInternalTime: timeRegistrationSettings.allowInternalTime,
			allowOutsideTaskDates: timeRegistrationSettings.allowOutsideTaskDates,
			allowExceedingEstimate: timeRegistrationSettings.allowExceedingEstimate,
			allowOutsideProjectDates: timeRegistrationSettings.allowOutsideProjectDates,
			requireNote: timeRegistrationSettings.requireNote,
		};
	}, []);
}
